/* Herbst-Deals – Restzeit + Aktionsbox. Geladen mit defer, nur während der Aktion.
   Eine Uhr für alle Countdowns (Update alle 30 s, pausiert wenn der Tab im Hintergrund ist), keine Observer.
   Die Texte entsprechen 1:1 snippets/hd-time.liquid, damit beim Laden nichts springt. */
(function () {
  'use strict';

  var timers = document.querySelectorAll('[data-hd-end]');
  var deal = document.querySelector('[data-hd-deal]');
  if (!timers.length && !deal) return;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function text(format, d, h, m) {
    if (format === 'short') {
      if (d >= 2) return 'noch ' + d + ' Tage';
      if (d === 1) return 'noch 1 Tag';
      if (h >= 1) return 'noch ' + h + ' Std.';
      return 'noch ' + m + ' Min.';
    }
    if (d >= 1) return 'Angebot endet in ' + (d === 1 ? '1 Tag' : d + ' Tagen') + (h > 0 ? ', ' + h + ' Std.' : '');
    if (h >= 1) return 'Angebot endet in ' + h + ' Std. ' + m + ' Min.';
    return 'Angebot endet in ' + m + ' Min.';
  }

  function set(el, sel, value) {
    var t = el.querySelector(sel);
    if (t && t.textContent !== value) t.textContent = value;
  }

  function tick() {
    var now = Date.now();
    Array.prototype.forEach.call(timers, function (el) {
      var end = Number(el.getAttribute('data-hd-end')) || 0;
      var s = Math.max(0, Math.floor((end - now) / 1000));
      var d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60);
      var format = el.getAttribute('data-hd-format');
      if (format === 'boxes') {
        set(el, '[data-hd-d]', String(d));
        set(el, '[data-hd-h]', pad(h));
        set(el, '[data-hd-m]', pad(m));
        if (s === 0) el.classList.add('is-over');
        return;
      }
      set(el, '[data-hd-label]', s === 0 ? 'Aktion beendet' : text(format, d, h, m));
    });
  }

  if (timers.length) {
    tick();
    var id = setInterval(tick, 30000);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { clearInterval(id); } else { tick(); id = setInterval(tick, 30000); }
    });
  }

  if (!deal) return;

  // Aktionsbox: Prozent + Ersparnis der gewählten Variante (Event des Themes, wie beim Stapeldeal).
  var ids = (deal.getAttribute('data-variant-ids') || '').split(',');
  var format = deal.getAttribute('data-money-format') || '{{amount_with_comma_separator}} €';

  function money(cents) {
    cents = Math.round(cents);
    var euros = Math.floor(cents / 100), dec = String(cents % 100);
    if (dec.length < 2) dec = '0' + dec;
    var dot = String(euros).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var comma = String(euros).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format
      .replace('{{amount_with_comma_separator}}', dot + ',' + dec)
      .replace('{{amount_no_decimals_with_comma_separator}}', dot)
      .replace('{{amount_no_decimals}}', comma)
      .replace('{{amount}}', comma + '.' + dec)
      .trim();
  }

  document.addEventListener('product:variant-change', function (e) {
    var v = e && e.detail && e.detail.variant;
    if (!v || ids.indexOf(String(v.id)) === -1) return;
    var price = Number(v.price) || 0, compare = Number(v.compare_at_price) || 0;
    if (compare <= price) { deal.hidden = true; return; }
    var save = compare - price;
    var pct = Math.floor((save * 200 + compare) / (compare * 2));
    set(deal, '[data-hd-deal-pct]', '−' + pct + ' %');
    set(deal, '[data-hd-deal-save]', money(save));
    deal.hidden = false;
  });
})();
